export const RQ_GET_ORDER_API = {
  url: 'api/order/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_GET_ORDER_BY_FILTER = {
  url: 'api/order/lookup/byfilter',
  method: 'GET',
  auth: true,
  search:true,
};

export const RQ_GET_ORDER_BY_USER_ID = {
  url: 'api/order/lookup/all/user/<%= id %>',
  method: 'GET',
  auth:true,
};

export const RQ_ORDER_REGISTRATION_API = {
  url:'api/order/register',
  method: 'POST',
  auth: true,
};

export const RQ_CREATE_RAZORPAY_ORDER ={
  url: 'api/payment/create/order',
  method: 'POST',
  auth: true,
};

export const RQ_VERIFY_RAZORPAY_PAYMENT ={
  url: 'api/payment/verify',
  method: 'POST',
  auth: true,
};
